import { render, staticRenderFns } from "./matching-card--simplified.vue?vue&type=template&id=a2f9b9ae&scoped=true&"
import script from "./matching-card--simplified.vue?vue&type=script&lang=ts&"
export * from "./matching-card--simplified.vue?vue&type=script&lang=ts&"
import style0 from "./matching-card--simplified.vue?vue&type=style&index=0&id=a2f9b9ae&lang=scss&scoped=true&"
import style1 from "./matching-card--simplified.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f9b9ae",
  null
  
)

export default component.exports